"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostFeatureExpTeamPropsSchema = exports.ListFeatureExpTeamPropsSchema = exports.FeatureExpTeamWithPaginationSchema = exports.FeatureExpTeamSchema = exports.FeatureExpTeamUserSchema = void 0;
const zod_1 = require("zod");
const project_1 = require("../project");
exports.FeatureExpTeamUserSchema = zod_1.z.object({
    id: zod_1.z.string(),
    email: zod_1.z.string(),
    firstName: zod_1.z.string().nullable(),
    lastName: zod_1.z.string().nullable(),
});
exports.FeatureExpTeamSchema = zod_1.z.object({
    id: zod_1.z.string(),
    name: zod_1.z.string(),
    users: zod_1.z.array(exports.FeatureExpTeamUserSchema),
    created_at: zod_1.z.string(),
    updated_at: zod_1.z.string(),
    created_by: zod_1.z.string().nullable(),
    updated_by: zod_1.z.string(),
    created_by_user: exports.FeatureExpTeamUserSchema.nullable(),
    projects: zod_1.z.array(project_1.FeatureExpProjectSchemaBase.pick({ id: true, name: true, description: true, emoji: true })),
});
exports.FeatureExpTeamWithPaginationSchema = zod_1.z.object({
    items: zod_1.z.array(exports.FeatureExpTeamSchema),
    current_items_count: zod_1.z.number(),
    current_page: zod_1.z.number(),
    total_count: zod_1.z.number(),
    items_per_page: zod_1.z.number(),
    last_page: zod_1.z.number(),
});
exports.ListFeatureExpTeamPropsSchema = zod_1.z.object({
    account_id: zod_1.z.string(),
    _max_per_page: zod_1.z.number().optional(),
});
exports.PostFeatureExpTeamPropsSchema = zod_1.z.object({
    accountId: zod_1.z.string(),
    name: zod_1.z.string(),
    users: zod_1.z.array(zod_1.z.string()),
});
//# sourceMappingURL=schemas.js.map